import { createRecipe } from './runtime';

const buttonConfig = {"name":"button","defaultVariants":{"size":"md","variant":"solid"},"variantMap":{"size":["2xl","lg","md","sm","xl","xs"],"variant":["ghost","hot","ink","link","outline","solid","subtle","surface"]}}

export const button = /* @__PURE__ */ createRecipe(buttonConfig)